var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsReward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 10C18.7604 10 21.0004 7.76 21.0004 5C21.0004 2.24 18.7604 0 16.0004 0C13.2404 0 11.0004 2.24 11.0004 5C11.0004 7.76 13.2404 10 16.0004 10ZM21.4504 15.6C21.0604 15.2 20.5704 15 20.0004 15H13.0004L10.9204 14.27L11.2504 13.33L13.0004 14H15.8004C16.1504 14 16.4304 13.86 16.6604 13.63C16.8904 13.4 17.0004 13.12 17.0004 12.81C17.0004 12.27 16.7404 11.9 16.2204 11.69L8.95037 9H7.00037V18L14.0004 20L22.0304 17C22.0404 16.47 21.8404 16 21.4504 15.6ZM5.00037 9H0.984375V20H5.00037V9Z",
    fill: "#FFBE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsReward);
export default __webpack_public_path__ + "static/media/coins_reward.51fc8f6bc154cd18ba1aabd2f191a427.svg";
export { ForwardRef as ReactComponent };